import { SvgIcon } from "@sveabank/cc-common";

type Props = {
	size?: number;
	className?: string;
};

const Spinner = ({ size, className = "text-interactive-primary" }: Props) => (
	<SvgIcon className={className} imageSrc="SPINNER" height={size} />
);

export default Spinner;
